/* eslint-disable no-undef */

import makeRequest from '@lib/fetchService';

const consentButtons = document.querySelectorAll(
  '.js-sofabuddy-consent-button'
);
const $successConsentPopup = $('#sofabuddy-success-consent-popup');
const redirectPathConsentGiven = $successConsentPopup.data('redirect-path');
const requestPath = $successConsentPopup.data('request-path');
const amplitudeEventConsent = $successConsentPopup.data('amplitude-event');
const eventPropertiesConsent = $successConsentPopup.data('event-properties');

const makeConsentRequest = (consentValue, showPopup = false) => {
  return makeRequest(requestPath, 'PATCH', { chatbot_consent: consentValue })
    .then(response => {
      if (response.ok) {
        Sofatutor.tracking.amplitude.track(
          amplitudeEventConsent,
          eventPropertiesConsent
        );
        if (showPopup) {
          openConsentPopup();
        }
      }
    })
    .catch(error => console.error('Error updating chatbot consent:', error));
};

consentButtons.forEach(button => {
  button.addEventListener('click', function() {
    makeConsentRequest(button.dataset.chatbotConsent, true);
  });
});

const openConsentPopup = () => {
  new Foundation.Reveal($successConsentPopup);
  $successConsentPopup.foundation('open');
  startProgressBar();
};

const startProgressBar = () => {
  const progressbar = document.querySelector(
    '.js-progress-bar .progress-meter'
  );
  let progress = Sofatutor.env == 'test' ? 90 : 0;

  const updateProgress = setInterval(() => {
    progress += 1;
    progressbar.style.width = `${progress}%`;

    if (progress >= 100) {
      clearInterval(updateProgress);
      window.location.href = redirectPathConsentGiven;
    }
  }, 50);
};
